import { removeData } from '@/services/storage.js'
import { readStoredFlag, writeStoredFlag } from '@/helpers/local-storage-flags.js'

export default {
  install(Vue) {
    // Logged User
    const isLogged = () => {
      return window.localStorage.getItem('loggedUser') !== null
    }
    const getLoggedUser = () => {
      const user = JSON.parse(window.localStorage.getItem('loggedUser'))
      if (!user) return { name: '' }
      return user
    }
    const setLoggedUser = (loggedUser) => {
      if (!loggedUser) return
      window.localStorage.setItem('loggedUser', JSON.stringify(loggedUser))
    }

    const setFingerPrint = (fingerPrint) => {
      window.localStorage.setItem('fingerprint', JSON.stringify(fingerPrint))
    }
    const isOnTestOrDemoAccount = () => {
      const loggedUser = getLoggedUser()
      return loggedUser?.id_external === 0
    }

    // Session
    const getSessionId = () => {
      return window.localStorage.getItem('session-id')
    }
    const setSessionId = (sessionId) => {
      if (!sessionId) return
      window.localStorage.setItem('session-id', sessionId)
    }
    const removeSessionId = () => {
      window.localStorage.removeItem('session-id')
    }

    // authCode
    const getAuthCode = () => {
      return window.localStorage.getItem('authCode')
    }
    const setAuthCode = (authCode) => {
      if (!authCode) return
      window.localStorage.setItem('authCode', authCode)
    }
    const removeAuthCode = () => {
      window.localStorage.removeItem('authCode')
    }

    // ecommerce
    const setIsEcommerce = (isEcommerce) => {
      writeStoredFlag('is-ecommerce', { isEcommerce })
    }
    const getIsEcommerce = () => {
      return readStoredFlag('is-ecommerce', 'isEcommerce', false)
    }

    // club
    const setIsClub = (isClub) => {
      writeStoredFlag('is-club', { isClub })
    }
    const getIsClub = () => {
      return readStoredFlag('is-club', 'isClub', false)
    }

    // Is MultiUser
    const setIsMultiUser = (isMultiUser) => {
      writeStoredFlag('is-multi-user', { isMultiUser })
    }

    const getIsMultiUser = () => {
      return readStoredFlag('is-multi-user', 'isMultiUser', false)
    }
    const removeIsMultiUser = () => {
      window.localStorage.removeItem('is-multi-user')
    }

    // Is Admin
    const setIsAdmin = (isAdmin) => {
      writeStoredFlag('is-admin', { isAdmin })
    }

    const getIsAdmin = () => {
      return readStoredFlag('is-admin', 'isAdmin', false)
    }
    const removeIsAdmin = () => {
      window.localStorage.removeItem('is-admin')
    }

    // Logout
    const logout = () => {
      window.localStorage.removeItem('session-id')
      window.localStorage.removeItem('has-pii-access')
      window.localStorage.removeItem('loggedUser')
      window.localStorage.removeItem('fingerprint')
      window.localStorage.removeItem('is-admin')
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('multi-user-token')
      window.localStorage.removeItem('allowed-modules')
      window.localStorage.removeItem('id_account')
      window.localStorage.removeItem('is-multi-user')
      window.localStorage.removeItem('admin-configuration')
      window.localStorage.removeItem('authCode')
      removeData('franchiseePermissions')
    }

    // Allowed modules
    const getAllowedModules = () => {
      return readStoredFlag('allowed-modules', 'modules', false)
    }

    const setAllowedModules = (allowedModules) => {
      if (!allowedModules) return
      writeStoredFlag('allowed-modules', { modules: allowedModules })
    }

    // Has PII Access
    const setPiiAccess = (hasPiiAccess) => {
      writeStoredFlag('has-pii-access', { hasPiiAccess })
    }

    const hasPiiAccess = () => {
      return readStoredFlag('has-pii-access', 'hasPiiAccess', false)
    }

    // Has PII Employees Access
    const setPiiEmployeesAccess = (hasPiiEmployeesAccess) => {
      writeStoredFlag('has-pii-employees-access', { hasPiiEmployeesAccess })
    }

    const hasPiiEmployeesAccess = () => {
      return readStoredFlag('has-pii-employees-access', 'hasPiiEmployeesAccess', false)
    }

    // Logged User
    Vue.prototype.$isLogged = Vue.isLogged = isLogged
    Vue.prototype.$getLoggedUser = Vue.getLoggedUser = getLoggedUser
    Vue.prototype.$setLoggedUser = Vue.setLoggedUser = setLoggedUser
    Vue.prototype.$setFingerPrint = Vue.setFingerPrint = setFingerPrint
    Vue.prototype.$isOnTestOrDemoAccount = Vue.isOnTestOrDemoAccount = isOnTestOrDemoAccount

    // Session ID
    Vue.prototype.$getSessionId = Vue.getSessionId = getSessionId
    Vue.prototype.$setSessionId = Vue.setSessionId = setSessionId
    Vue.prototype.$removeSessionId = Vue.removeSessionId = removeSessionId

    // authCode
    Vue.prototype.$getAuthCode = Vue.getAuthCode = getAuthCode
    Vue.prototype.$setAuthCode = Vue.setAuthCode = setAuthCode
    Vue.prototype.$removeAuthCode = Vue.removeAuthCode = removeAuthCode

    // Is Admin
    Vue.prototype.$getIsAdmin = Vue.getIsAdmin = getIsAdmin
    Vue.prototype.$setIsAdmin = Vue.setIsAdmin = setIsAdmin
    Vue.prototype.$removeIsAdmin = Vue.removeIsAdmin = removeIsAdmin

    // ecommerce
    Vue.prototype.$setIsEcommerce = Vue.setIsEcommerce = setIsEcommerce
    Vue.prototype.$getIsEcommerce = Vue.getIsEcommerce = getIsEcommerce

    // club
    Vue.prototype.$setIsClub = Vue.setIsClub = setIsClub
    Vue.prototype.$getIsClub = Vue.getIsClub = getIsClub

    // Is MultiUser
    Vue.prototype.$getIsMultiUser = Vue.getIsMultiUser = getIsMultiUser
    Vue.prototype.$setIsMultiUser = Vue.setIsMultiUser = setIsMultiUser
    Vue.prototype.$removeIsMultiUser = Vue.removeIsMultiUser = removeIsMultiUser

    // Logout
    Vue.prototype.$logout = Vue.logout = logout

    // Allowed modules
    Vue.prototype.$getAllowedModules = Vue.getAllowedModules = getAllowedModules
    Vue.prototype.$setAllowedModules = Vue.setAllowedModules = setAllowedModules

    // Has PII access
    Vue.prototype.$hasPiiAccess = Vue.hasPiiAccess = hasPiiAccess
    Vue.prototype.$setPiiAccess = Vue.setPiiAccess = setPiiAccess

    // Has PII Employees access
    Vue.prototype.$hasPiiEmployeesAccess = Vue.hasPiiEmployeesAccess = hasPiiEmployeesAccess
    Vue.prototype.$setPiiEmployeesAccess = Vue.setPiiEmployeesAccess = setPiiEmployeesAccess

    Object.defineProperty(Vue.prototype, '$loggedUser', {
      get: () => {
        return getLoggedUser()
      },
    })

    Object.defineProperty(Vue, 'loggedUser', {
      get: () => {
        return getLoggedUser()
      },
    })
  },
}
